module.exports = __webpack_public_path__ + "static/media/database.2119b6f9.png";